<template>
  <div>

    </div>
  <RouterView></RouterView>
</template>
<script setup>

</script>
<style>
html, body {
  width: 100vw;
  height: 100vh;
  margin: 0;
  padding: 0;
}


</style>
